import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {SmartFilterBase} from '@shared/components/smart-filters/smart-filter-base.component';
import {Observable, Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {LawChangesGroupSummary, LawChangesSummary} from '@shared/models/law-changes-summary';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {map, takeUntil, distinctUntilChanged, withLatestFrom} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {SmartGridService} from '@core/services/smart-grid.service';
import {Configuration} from '@shared/models/configuration';
import {ActivatedRoute, Router} from '@angular/router';
import {StringUtility} from '@shared/utility/string-utility';
import {TimeZoneService} from '@core/services/time-zone.service';
import {ISmartGridDataCollectionState} from '@shared/store/reducers/smart-grid.reducers';
import {InvalidateSmartGridAction} from '@shared/store/actions/smart-grid.actions';
import {observableToBeFn} from 'rxjs/internal/testing/TestScheduler';
import {hasFeature} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {DashboardFeatures} from '../dashboard-features';


@Component({
    standalone: false,
    selector: 'particle-law-changes-widget',
  templateUrl: './law-changes-widget.component.html',
  styleUrls: ['./law-changes-widget.component.scss']
})
export class LawChangesWidgetComponent extends SmartFilterBase implements OnInit, OnDestroy {
  // lawChangesSummary$: Observable<LawChangesSummary>;
  hasData: boolean = false;
  hasData$: Observable<boolean>;
  dataLoaded: boolean = false;
  lawChangesResponse$: Observable<any>;
  lawChanges: any[];
  hasFeature$: Observable<any>;
  // dataFetchCount: number;
  // groups: LawChangesGroupSummary[];
  // initializedGrids: string[];
  // gridDataLoaded: string[];
  // sourceType: string;
  // currentIndex = 0;
  // currentGroup: LawChangesGroupSummary;
  // gridInitialized: boolean = false;
  routeParams$: Observable<any>;
  newsDateString: string;
  fromDate: Date;
  toDate: Date;
  features: any;
  unsubscribe$ = new Subject<void>();
  inited: boolean = false;

  constructor(public changeDetectorRef: ChangeDetectorRef, private store: Store<IQueryState>, // private smartGridStore: Store<ISmartGridDataCollectionState>,
              private activatedRoute: ActivatedRoute, private router: Router, private securityStore: Store<SecurityState>, // private smartGridService: SmartGridService,
              // private timeZoneService: TimeZoneService
  ) {
    super(changeDetectorRef);
  }

  ngOnInit() {
    this.inited = false;
    this.dataLoaded = false;
    // this.dataFetchCount = 0;
    this.queryKey = this.currentFilter.arguments['QueryKey'];
    // this.initializedGrids = [];
    // this.gridDataLoaded = [];
    if (!this.queryKey) {
      return;
    }
    this.hasFeature$ = this.securityStore.pipe(select(hasFeature));
    this.lawChangesResponse$ = this.store.pipe(select(getQueryResponse, this.queryKey));
    this.lawChangesResponse$.pipe(takeUntil(this.unsubscribe$)).subscribe(lawChangesReponse => {
      if (lawChangesReponse && this.inited) {
        this.dataLoaded = true;
        this.lawChanges = lawChangesReponse.items;
        this.hasData = this.lawChanges && lawChangesReponse.recordCount > 0;
      }
      this.inited = true;
      this.currentFilter.title = this.hasData ? `Law Changes (${lawChangesReponse.recordCount})` : 'Law Changes';
    });
    this.activatedRoute.queryParams.pipe(withLatestFrom(this.hasFeature$), takeUntil(this.unsubscribe$)).subscribe(results => {
      const queryParams = results[0];
      this.features = results[1];
      this.queryParameters = {...queryParams};
      if (this.queryParameters.groupId) {
        delete this.queryParameters.groupId;
        this.router.navigate([], {relativeTo: this.activatedRoute, queryParams: this.queryParameters});
      }

      if (queryParams.newsDate) {
        if (this.newsDateString !== queryParams.newsDate) {
          this.dataLoaded = false;
          this.newsDateString = queryParams.newsDate;
          if (!this.features(DashboardFeatures.CR)) {
            let current_datetime = new Date()
            let formatted_date = current_datetime.getFullYear() + '-' + (current_datetime.getMonth() + 1) + '-' + current_datetime.getDate()
            //console.log(formatted_date)
            this.newsDateString = formatted_date;
          }
          QueryProvider.invokeQuery(this.store, this.queryKey, {
            '[NEWS_DATE]': this.newsDateString
          });
          const newsDate = new Date(this.newsDateString);
          this.toDate = new Date();
          this.fromDate = new Date();
          this.toDate.setDate(newsDate.getDate() - 1);
          this.fromDate.setDate(newsDate.getDate() - 7);
          // this.gridDataLoaded = [];
        }
      }
    });


    this.hasData$ = this.lawChangesResponse$.pipe(map(lawChangesResponse => {
      const hasData = lawChangesResponse && lawChangesResponse.recordCount > 0;
      return hasData;
    }));

    //this.sourceType = this.currentFilter.arguments['SourceType']; //TODO: find alternatives
    // this.valueKey = this.currentFilter.arguments['ValueKey'];
    // this.lawChangesSummary$ = this.store.pipe(select(getQueryResponse, this.queryKey), map(response => {
    //   if (!response) {
    //     return null;
    //   }
    //   let lawChangesSummary: LawChangesSummary;
    //   if (this.valueKey) {
    //     lawChangesSummary = response[this.valueKey];
    //   } else {
    //     lawChangesSummary = response;
    //   }
    //   return lawChangesSummary;
    // }));
    // this.hasData$ = this.lawChangesSummary$.pipe(
    //   map(lawChangesSummary => {
    //     const hasData = lawChangesSummary && lawChangesSummary.totalRecordCount > 0;
    //     this.currentFilter.title = hasData ? `Law Changes (${lawChangesSummary.totalRecordCount})` : 'Law Changes';
    //     this.groups = hasData ? lawChangesSummary.groups : [];
    //     if (this.queryParameters.groupId) {
    //       if (hasData) {
    //         const currentItem = this.groups.find(group => group.groupId === this.queryParameters.groupId);
    //         if (currentItem) {
    //           this.currentGroup = currentItem;
    //           this.currentIndex = currentItem ? this.groups.indexOf(currentItem) : 0;
    //         }
    //         else {
    //           this.currentGroup = this.groups[0];
    //           this.currentIndex = 0;
    //         }
    //       } else {
    //         // delete this.queryParameters.groupId;
    //         // this.router.navigate([], {relativeTo: this.activatedRoute, queryParams: this.queryParameters});
    //       }
    //     }
    //     else {
    //       this.currentGroup = this.groups[0];
    //       this.currentIndex = 0;
    //     }
    //     // this.refreshGrid();
    //
    //     return hasData;
    //   })
    // );
  }

  // isGridVisible(group: LawChangesGroupSummary) {
  //   if (group.groupId === this.currentGroup.groupId || this.gridDataLoaded.find(e => e === group.groupId)) {
  //     return true;
  //   }
  //   return false;
  // }

  refreshGrid() {
    // if (!this.groups || this.groups.length <= 0) {
    //   return;
    // }
    // let isInitialized = this.initializedGrids.find(e => e === this.currentGroup.groupId);

    // if (isInitialized) {
    //   let dataLoaded = this.gridDataLoaded.find(e => e === this.currentGroup.groupId);
    //   if (!dataLoaded) {
    //     const smartGridConfig = Configuration.getSmartGridConfig(this.currentGroup.sourceType);
    //     smartGridConfig.Parameters['TOPIC_GROUP'] = this.currentGroup.groupId;
    //     smartGridConfig.Parameters['NEWS_DATE'] = this.newsDateString;
    //
    //     Configuration.setSmartGridConfig(this.currentGroup.sourceType, smartGridConfig);
    //     this.smartGridStore.dispatch(new InvalidateSmartGridAction(this.currentGroup.sourceType, true, false, false));
    //     this.gridDataLoaded.push(this.currentGroup.groupId);
    //   }
    // }
    // else {
    //   const smartGridConfig = Configuration.getSmartGridConfig(this.currentGroup.sourceType);
    //   smartGridConfig.Parameters['TOPIC_GROUP'] = this.currentGroup.groupId;
    //   smartGridConfig.Parameters['NEWS_DATE'] = this.newsDateString;
    //   smartGridConfig.ItemsUrlIndex = 1;
    //   Configuration.setSmartGridConfig(this.currentGroup.sourceType, smartGridConfig);
    //   this.smartGridService.initDataProvider(this.currentGroup.sourceType);
    //   this.initializedGrids.push(this.currentGroup.groupId);
    //   this.gridDataLoaded.push(this.currentGroup.groupId);
    // }
  }


  expanded(group: LawChangesGroupSummary, index: number) {
    // this.currentIndex = index;
    // this.currentGroup = group;
    // this.refreshGrid();
    // this.currentGroupId = group.groupId;
    // if (!this.sourceType) {
    //   return;
    // }
    // const smartGridConfig = Configuration.getSmartGridConfig(this.sourceType);
    // smartGridConfig.Parameters['TOPIC_GROUP'] = group.groupId;
    // smartGridConfig.Parameters['NEWS_DATE'] = this.newsDateString;
    // Configuration.setSmartGridConfig(this.sourceType, smartGridConfig);
    // if (!this.gridInitialized) {
    //   this.smartGridService.initDataProvider(this.sourceType);
    //   this.gridInitialized = true;
    // } else {
    //   this.smartGridStore.dispatch(new InvalidateSmartGridAction(this.sourceType, true, false, false));
    // }
    // this.queryParameters.groupId = group.groupId;
    // this.router.navigate([], {relativeTo: this.activatedRoute, queryParams: this.queryParameters});
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
